<template>
  <div class="hudon">
    <Header :index="'hudo'" style="position:fixed;top:0"></Header>
    <!-- <div class="hudon-content" :style="'height:'+ fullWidth/1.87 + 'px;'"> -->
    <div class="hudon-content">
      <img class="hudotitle" src="../assets/imgs/hudotitle.png" alt />
      <div class="hudon-content-img">
        <img src="../assets/imgs/hodoLeft.png" alt />
      </div>
      <div class="hudon-content-center">
        <img :src="data.centerPic" alt />
        <h2>{{$i18n.locale == "zh" ?data.company:data.companyEn}}</h2>
        <p v-html="$i18n.locale == 'zh' ?data.description:data.descriptionEn"></p>
        <div @click="isbusinesscardexchange" class="displayroom-title displayroom-title-one">
          {{$t("message.businesscardexchange")}}
          <div class="displayroom-img displayroom-one">
            <div class="displayroom-ico"></div>
          </div>
        </div>
        <div
          @click="interactivezonedialogVisible = true"
          class="displayroom-title displayroom-title-two"
        >
          {{$t("message.interactivezone")}}
          <div class="displayroom-img displayroom-one">
            <div class="displayroom-ico"></div>
          </div>
        </div>
        <div @click="watchvideo" class="displayroom-title displayroom-title-three">
          {{$t("message.watchvideo")}}
          <div class="displayroom-img displayroom-one">
            <div class="displayroom-ico"></div>
          </div>
        </div>
        <div @click="datadownload" class="displayroom-title displayroom-title-four">
          {{$t("message.datadownload")}}
          <div class="displayroom-img displayroom-one">
            <div class="displayroom-ico"></div>
          </div>
        </div>
      </div>
      <div class="hudon-content-img">
        <img src="../assets/imgs/hodoRight.png" alt />
      </div>
    </div>
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
    <div
        class="dialogTitle"
      >{{$i18n.locale == "zh" ?data.title:data.titleEn}} {{ $t('message.productinformation')}}</div>
      <div class="enterpriseList">
        <!-- <div class="zl-top">
          <img src="../assets/imgs/zst.png" />
          {{i.name}}
        </div>-->
        <ul class="information">
          <li class="information-item" v-for="(l,i) in material" :key="i">
            <div class="item item-left">
              <!-- <img src="../assets/imgs/fh.png" /> -->
              <span>{{l | fileName(l)}}</span>
            </div>
            <!-- <div class="item item-right"> -->
            <i @click="downloadCodeImg(l)" class="el-icon-view">{{$t("message.see")}}</i>

            <!-- <a :href="l" target="_blank" :download="l"> -->
            <!-- <i @click="download(l)" class="el-icon-download">{{$t("message.download")}}</i> -->
            <!-- </a> -->

            <!-- </div> -->
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="interactivezonedialogVisible"
      custom-class="interactivezonedialog"
    >
    <div
        class="dialogTitle"
      >{{$i18n.locale == "zh" ?data.title:data.titleEn}} {{ $t('message.interactivezone')}}</div>
      <div class="enterpriseList">
        <ul class="information">
          <li class="information-item">
            <div class="item item-left">
              <span>{{data.website?data.website.split('+')[1]:''}}</span>
            </div>
            <div @click="interactiveZone" class="icoText">
              <img src="../assets/imgs/pcGo.png" alt="">
              <span>{{$t("message.join1")}}</span>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog center :close-on-click-modal="false" :visible.sync="videodialogVisible">
      <div
        class="dialogTitle"
      >{{$i18n.locale == "zh" ?data.title:data.titleEn}} {{ $t('message.watchvideo')}}</div>
      <div class="enterpriseList">
        <ul class="information">
          <li class="information-item" v-for="(l,i) in videoList" :key="i">
            <div class="item item-left">
              <span>{{l?l.split('+')[1]:''}}</span>
            </div>
            <i
              @click="gotowatchvideo(l.split('+')[0])"
              class="el-icon-video-play"
            >{{$t("message.Play")}}</i>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      center
      :close-on-click-modal="false"
      :title="$t('message.businesscardexchange')"
      :visible.sync="exchangedialogVisible"
      @open="getData"
      custom-class="exchangedialog"
    >
      <el-tabs v-model="activeName">
        <!-- <el-tab-pane :label="$t('message.mynamecard')" name="first">
          <ul>
            <li>{{$t('message.Name')}}：{{personalCard.name}}</li>
            <li>{{$t('message.Company')}}：{{personalCard.company}}</li>
            <li>{{$t('message.Position')}}：{{personalCard.job}}</li>
            <li>{{$t('message.Mobile')}}：{{personalCard.phone?personalCard.phone.split('-')[1].split(' ')[0]:''}}</li>
            <li>{{$t('message.Email')}}：{{personalCard.email?personalCard.email.split(' ')[0]:""}}</li>
          </ul>
          :label="$t('message.EnterpriseNameCard')"
        </el-tab-pane>-->
        <el-tab-pane name="second">
          <span
            slot="label"
            :style="'display: inline-block;height: 100px;width: 100px;background-image:url(' + companyCard.logo + ');background-size:100%;background-repeat: no-repeat;background-position: center center;}'"
          ></span>
          <ul>
            <li>
              {{$t('message.Name')}}：
              <span
                class="lable-item"
              >{{$i18n.locale == 'zh'? companyCard.contactName:companyCard.contactNameEn}}</span>
            </li>
            <li>
              {{$t('message.Company')}}：
              <span
                class="lable-item"
              >{{$i18n.locale == 'zh'? companyCard.company:companyCard.companyEn}}</span>
            </li>
            <li>
              {{$t('message.Position')}}：
              <span class="lable-item">{{$i18n.locale == 'zh'? companyCard.job:companyCard.jobEn}}</span>
            </li>
            <li>
              {{$t('message.telephone')}}：
              <span class="lable-item">{{companyCard.phone}}</span>
            </li>
            <li>
              {{$t('message.Email')}}：
              <span class="lable-item">{{companyCard.email}}</span>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
      <div class="dialog-button">
        <el-button
          @click="businesscardexchange"
          size="medium"
          type="primary"
          round
        >{{$t('message.businesscardexchange')}}</el-button>
      </div>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Qs from "qs";
import axios from "axios";
import { getToken, removeToken } from "@/utils/auth";
import store from "../store";
import { download } from "../api/oss";
import {
  apiMethod,
  pushLog,
  logProdType,
  targetType,
  eventType,
  pageType,
  areaType
} from "../global/config";
export default {
  components: {
    Footer,
    Header
  },

  computed: {
    // videoTitle() {
    //   return this.$i18n.locale == 'zh' ? this.data.company:this.data.companyEn + this.$t('message.watchvideo')
    // }
  },
  watch: {},
  filters: {
    fileName(file) {
      return file.substring(file.lastIndexOf("/") + 1, file.length);
    }
  },
  data() {
    let _this = this;
    return {
      activeName: "second",
      interactivezonedialogVisible: false,
      videodialogVisible: false,
      dialogVisible: false,
      exchangedialogVisible: false,
      fullWidth: document.documentElement.clientWidth,
      data: "",
      exchangeData: "",
      companyCard: "",
      personalCard: "",
      material: "",
      videoList: ""
    };
  },
  methods: {
    downloadCodeImg(path) {
      pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.LINK,
        targetType.EXHIBITOR,
        path,
        areaType.POPUP,
      );
      window.open(path.split("+")[0], "_blank");
      // this.downloadFile(res.data.path)
      // let a = document.createElement("a");
      // a.download = name || "pic";
      // a.href = path.split('+')[0];
      // a.click();
    },
    datadownload() {
      if (getToken()) {
        this.dialogVisible = true;
      } else {
        this.$parent.centerDialogVisible = true;
      }
    },
    isbusinesscardexchange() {
      if (getToken()) {
        this.exchangedialogVisible = true;
      } else {
        this.$parent.centerDialogVisible = true;
      }
    },
    downloadExcel(url) {
      let a = document.createElement("a");
      a.href = url;
      a.click();
    },
    download(url) {
      axios.defaults.headers["content-type"] = "application/json;charset=UTF-8";
      download({ path: url }).then(res => {
        let blob = new Blob([res]);
        // , {
        //   type: "application/vnd.ms-excel"
        // }
        console.log(blob);
        let fileName1 = url.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let fileNameLength = url.length; //取到文件名长度
        let fileFormat = url.substring(fileName1, fileNameLength);
        let fileName = Date.parse(new Date()) + fileFormat;
        if (window.navigator.msSaveOrOpenBlob) {        
          navigator.msSaveBlob(blob, fileName);
        } else {       
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          //释放内存
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth;
      if (this.fullWidth < 1080) {
        this.fullWidth = 1080;
      }
    },
    search() {
      this.$c(this.$g.getExhibitorHall, {
        id: this.$route.params.id
      }).then(res => {
        console.log(res);
        this.data = res.data.exhibitorDetailVoList[0];
        // if (this.data.description) {
        //   this.data.description = this.data.description.replace(/\n/g, "<br>");
        // }
        // if (this.data.descriptionEn) {
        //   this.data.descriptionEn = this.data.descriptionEn.replace(
        //     /\n/g,
        //     "<br>"
        //   )
        // }
        if(res.data.exhibitorDetailVoList[0].material){
          this.material = this.data.material.split("<&>");
        }
        
      });
    },
    getData() {
      this.$c(this.$g.exhibitorCardShow, {
        id: this.$route.params.id
      }).then(res => {
        console.log(res.data);
        this.companyCard = res.data.companyCard;
        this.personalCard = res.data.personalCard;
      });
    },
    businesscardexchange() {
      this.$c(
        this.$g.exhibitorCardChange,
        Qs.stringify({
          id: this.$route.params.id * 1
        })
      ).then(res => {
        pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.CLICK,
        targetType.EXHIBITOR,
        this.$route.params.id,
        areaType.POPUP
      );
        this.$message({
          message:
            this.$i18n.locale == "zh"
              ? res.message.split("/")[0]
              : res.message.split("/")[1],
          type: "success",
          duration: 3 * 1000
        });
      });
    },
    interactiveZone() {
      pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.LINK,
        targetType.EXHIBITOR,
        this.data.website.split("+")[0],
        areaType.POPUP,
      );
      window.open(this.data.website.split("+")[0], "_blank");
    },
    watchvideo() {
      if(this.data.exhibitorVideoUrl){
        this.videoList = this.data.exhibitorVideoUrl.split("<&>");
      }
      if (this.videoList.length == 1) {
        pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.LINK,
        targetType.EXHIBITOR,
        this.videoList[0],
        areaType.POPUP,
      );
        window.open(this.videoList[0].split("+")[0], "_blank");
      } else {
        this.videodialogVisible = true;
      }
    },
    gotowatchvideo(url) {
      pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.LINK,
        targetType.EXHIBITOR,
        url,
        areaType.POPUP,
        );
      window.open(url, "_blank");
    },
    beforeunloadFn(e) {
      console.log("关闭");
      pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.PAGE_CLOSE,
        targetType.PAGE,
        this.$route.path
      );
    },
    beforeloadFn(e) {
      console.log("刷新");
      pushLog(
        this,
        logProdType.PC,
        pageType.INTERACTIVE_DETAIL,
        eventType.PAGE_LOAD,
        targetType.PAGE,
        this.$route.path
      );
    }
  },
  created() {
    window.addEventListener("beforeunload", e => this.beforeloadFn(e));
    this.search();
  },
  mounted() {
    axios.interceptors.request.use(
      config => {
        console.log(store.getters.token);
        if (store.getters.token) {
          config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config;
      },
      error => {
        // Do something with request error
        console.log(error); // for debug
        Promise.reject(error);
      }
    );
    window.scrollTo(0, 0);
    window.addEventListener("resize", this.handleResize);
    this.$ba.trackPageview(this.$route.path);
  },
  destroyed() {
    window.removeEventListener("beforeunload", e => this.beforeunloadFn(e));
  }
};
</script>
<style lang="less">
@import "@/style/variable.less";
.icoText{
  line-height: 1;
  cursor: pointer;
  img{
    display: inline-block;
    margin-right: 10px;
  }
  span{
    vertical-align: middle;
    color: @color;
  }
}
.interactivezonedialog{
  &.el-dialog{
    min-height: 30%
  }
}
.exchangedialog {
  ul {
    li {
      margin-bottom: 10px;
    }
  }
}
.lable-item {
  // font-weight: bold;

  display: inline-block;
}
@keyframes myfirst {
  0% {
    // transform: scale(1);
    transform: translateY(0);
    // background: url(../assets/imgs/WAIT.png) no-repeat;
    background-size: contain;
  }
  100% {
    // transform: scale(1.1);
    transform: translateY(10px);
    // background: url(../assets/imgs/WAIT.png) no-repeat;
    background-size: contain;
  }
}
.dialog-button {
  text-align: center;
  margin: 40px 0;
  .el-button {
    background-color: @color;
    width: 180px;
    // height: 48px;
    // border-radius:24px;
    // font-size:18px;
  }
}
.displayroom-title {
  cursor: pointer;
  display: inline-block;
  padding: 8px 17px;
  border: 2px solid @color-A;
  color: @color-A;
  border-top-left-radius: 14px;
  border-bottom-right-radius: 14px;
  background: rgba(35, 69, 110, 0.6);
  font-size: 12px;
  position: absolute;
  animation: myfirst 1s linear infinite alternate;
  box-shadow: 0 0 20px 0 #eeeeee;
  .displayroom-img {
    padding: 6px;
    border: 2px solid @color-A;
    border-radius: 50%;
    background: rgba(35, 69, 110, 0.8);
    display: inline-block;
    position: absolute;
  }
  .displayroom-ico {
    width: 6px;
    height: 6px;
    background: @color-A;
    border-radius: 50%;
  }
}
.displayroom-one {
  left: -15px;
  bottom: -30px;
}
.exchangedialog {
  .el-dialog__body {
    padding: 20px 100px;
  }
  .el-dialog__header {
    padding: 20px 100px;
  }
}
</style>
<style lang="less" scoped>
.dialogTitle {
  text-align: center;
  font-size: 18px;
  color: #303133;
  font-weight: bold;
}
.hudon {
  padding-top: 100px;

  .hudon-content {
    color: #ffffff;
    background: url("../assets/imgs/bg.png") center center no-repeat;
    background-size: 100% 100%;
    padding: 13% 0 99px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    position: relative;
    .hudotitle {
      position: absolute;
      top: 40px;
      right: 40px;
      height: 90px;
    }
    .hudon-content-img {
      flex: 0 0 155px;
      img {
        width: 100%;
        margin-top: 80px;
      }
    }
    .hudon-content-center {
      flex: 0 0 900px;
      text-align: center;
      margin: 0 25px;
      position: relative;
      h2 {
        margin: 30px 0 15px 0;
        letter-spacing: 3px;
      }
      p {
        padding: 0 5%;
        text-align: left;
        white-space: break-spaces;
      }
      .displayroom-title-one {
        top: 226px;
        left: 120px;
      }
      .displayroom-title-two {
        top: 285px;
        right: 400px;
      }
      .displayroom-title-three {
        top: 203px;
        right: 242px;
      }
      .displayroom-title-four {
        top: 281px;
        right: 150px;
      }
      img {
        width: 100%;
        // height: 435px;
      }
    }
  }
}
.enterpriseList {
  border-bottom: 1px solid rgba(169, 196, 242, 1);
  padding-bottom: 4px;
  &:last-child {
    border: none;
  }
  .zl-top {
    /*background: url("../assets/imgs/zst.png") 0 2px no-repeat;*/
    width: 1280px;
    vertical-align: middle;
    font-size: 20px;
    color: #222222;
    padding: 30px 0;

    img {
      display: inline-block;
      width: 30px;
      height: 33px;
      margin-right: 17px;
    }
  }
  .information {
    .information-item {
      padding: 21px 33px 21px 22px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(168, 195, 242, 1);
      &:last-child {
        border-bottom: none;
      }
      //   &:nth-child(2n + 1) {
      //     background: rgba(245, 249, 253, 1);
      //   }
      i {
        color: #386ba9;
        cursor: pointer;
        line-height: 1;
        flex: 0 0 auto;
        margin-left: 10px;
        &:first-child {
          margin-right: 54px;
        }

        &::before {
          font-size: 14px;
          margin-right: 10px;
        }
      }
      .item {
        font-size: 15px;
        line-height: 1;
        img {
          height: 32px;
          width: 31px;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          vertical-align: middle;
          color: #616161;
        }
      }
    }
  }
}
</style>